import React, { Component } from 'react';

import { Link } from 'react-router-dom';

import LoadingIndication from '../../common/loading-indicator'
import NewsletterBox from '../../newsletters/newsletter-box';
import SiteSubscription from '../../common/site-subscription';
import Button from '../../common/button/button';

import './newsletters-section.css';

export default class NewslettersSection extends Component {
  render() {
    const { newslettersTypes } = this.props;

    if (!newslettersTypes) {
      return (
        <div className='newsletters-section-container'>
          <LoadingIndication />
        </div>
      );
    }

    if (newslettersTypes.length === 0) {
      return (
        <div className='newsletters-section-container'>
          <p>There are no newsletters</p>
        </div>
      );
    }
    
    return (
      <section className='newsletters-types'>
        {
          newslettersTypes.map((newslettersTypeData, i) => 
            <NewslettersType key={ `newsletters-type-${i}` } { ...newslettersTypeData } className={ i % 2 === 0 ? '' : 'dark' } />
          )
        }
      </section>
    );
  }
}

const NewslettersType = ({ typeName, universalTagName, newsletters, className, }) => {
  return (
    <div className={ `${ className } section-container newsletters-type` }>
      <h3 className='section-title'>{ typeName }</h3>

      <div className='newsletter-type-badge'>
        <Link to={ `/newsletters/ag/${ universalTagName }`} title={ typeName }>
          <img src={ `/images/newsletters/badges/${ universalTagName }.png` } title={ typeName } />
        </Link>
      </div>

      <div className='newsletters'>
        {
          newsletters.map(newsletter => 
            <div key={ `newsletters-${newsletter._id}` } className='newsletter-container little-grow-animation'>
              <NewsletterBox { ...newsletter } tag={ newsletter.universalTagName } />
            </div>
          )
        }
      </div>

      <SiteSubscription source='Home' mailingListKey={ universalTagName } isInline={ true } />

      {/*<Link to={ `/newsletters/ag/${ universalTagName }`} title={ typeName }>
        <Button 
          label='Read More'
          isDark={ className !== 'dark' } />
      </Link>*/}
    </div>    
  )
};

/*import { Link } from 'react-router-dom';

import LoadingIndication from '../../common/loading-indicator';
import newslettersService from '../../../services/newsletters';
// import SmartAd from '../../ads/smart-ad';

import './newsletters-section.css';

export default class NewslettersSection extends Component {
  // componentDidMount() {
  //   newslettersService.getNewslettersTypes()
  //     .then((newslettersTypes) => {
  //       this.setState({
  //         isLoading: false,
  //         newslettersTypes,
  //       });
  //     })
  //     .catch((error) => {
  //       this.setState({
  //         isLoading: false,
  //         isError: true
  //       });
  //     });
  // }
  
  render() {
    let extraJSX;

    const { isLoading, isError, newslettersTypes } = this.state;

    if (isLoading) {
      extraJSX = (
        <LoadingIndication />
      );
    }
    else {
      if (isError) {
        extraJSX = (
          <div>
            <p>There are no newsletters</p>
          </div>
        );
      }
      else {
        extraJSX = (
          <div className='newsletters-types'>
            {
              newslettersTypes.map(newsletter => 
                <div key={ `newsletter-type-${newsletter.universalTagName}` } className='little-grow-animation'>
                  <NewsletterType {...newsletter} />
                </div>
              )
            }
          </div>
        );
      }
    }

    return (
      <section className='newsletters-section-container'>
        <h3 className='section-title'>
          Newsletters
        </h3>

        <hr className='section-title-separator' />
        
        { extraJSX }
      </section>
    );
  }
}

const NewsletterType = ({ universalTagName, name }) => {
  return (
    <div className='newsletter-type'>
      <Link to={ `/newsletters/ag/${universalTagName}`} title={name}>
        <img src={ `/images/newsletters/badges/${universalTagName}.png` } title={ name } />
      </Link>
    </div>
  )
};*/